import { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { computeBankIdQrData } from "@/auth/bankid-qr-data";

interface Props {
  qrStartToken: string;
  qrStartSecret: string;
  initTimeMs: number;
  size?: number;
}

// CAR-5: rolling BankID QR for the admin login. Data string refreshes
// every second so a screenshotted QR can't be replayed; the BankID app
// on a nearby device scans the live code and continues straight to PIN
// entry. Mounted by LoginRoute during `status==='polling'`.
export function BankIdQr({
  qrStartToken,
  qrStartSecret,
  initTimeMs,
  size = 220,
}: Props) {
  const [data, setData] = useState(() =>
    computeBankIdQrData(qrStartToken, qrStartSecret, initTimeMs, Date.now()),
  );

  useEffect(() => {
    const id = window.setInterval(() => {
      setData(
        computeBankIdQrData(
          qrStartToken,
          qrStartSecret,
          initTimeMs,
          Date.now(),
        ),
      );
    }, 1000);
    return () => window.clearInterval(id);
  }, [qrStartToken, qrStartSecret, initTimeMs]);

  return (
    <div className="flex justify-center">
      <QRCodeSVG value={data} size={size} aria-label="BankID QR-kod" />
    </div>
  );
}
